import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c1116b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "white-card" }
const _hoisted_2 = { class: "white-card__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "white-card__title" }, "CPITN / BPE", -1))
const _hoisted_4 = { class: "white-card__content" }
const _hoisted_5 = { class: "white-card__footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Подтвердить ")

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { ScreeningControllerInterface } from '@/pages/ScreeningPage/screeningController'
import CpitnModalWindow from '@/pages/ScreeningPage/components/CpitnModalWindow.vue'
import CpitnTable from '@/pages/ScreeningPage/components/CpitnTable.vue'
import IconTemplate from '@/apps/components/IconTemplate.vue'

interface Props {
  screeningController: ScreeningControllerInterface
}


export default /*#__PURE__*/_defineComponent({
  props: {
    screeningController: null
  },
  emits: ['saveReport', 'updateReport'],
  setup(__props: any) {




const route = useRoute()
const isModalVisible = ref(false)
const isCreationPage = computed(() => route.params.reportId === '0')

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "white-card__tip",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isModalVisible.value = true))
        }, [
          _createVNode(IconTemplate, {
            height: "22",
            name: "tip",
            width: "22"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CpitnTable, { "screening-controller": __props.screeningController }, null, 8, ["screening-controller"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(isCreationPage))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              disabled: !__props.screeningController.isUpdatedExamination(),
              class: "el-button--screening",
              round: "",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateReport')))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["disabled"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "el-button--screening",
              round: "",
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saveReport')))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(CpitnModalWindow, {
      "is-modal-visible": isModalVisible.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isModalVisible.value = false))
    }, null, 8, ["is-modal-visible"])
  ], 64))
}
}

})